import { useState } from "react";
import "./CrunchTimeLabel.scss";
export default function CrunchTimeLabel(prps) {
  return <p className="crunch-time-label">CRUNCH TIME</p>;
}
